import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleRight,
  faArrowLeft,
  faPencil,
  faCopy,
} from "@fortawesome/free-solid-svg-icons";
import logo from "../assets/image/logo.png";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import settings from "../assets/image/settings.png";
import dashboard from "../assets/image/dashboard.png";
import arevenue from "../assets/image/arevenue.png";
import umanage from "../assets/image/umanage.png";
import xls from "../assets/image/xls.png";
// import customer from "../assets/image/umanage.png";
import {
  GetjobConfigByID,
  GetjobConfiguration,
  jobConfiguration,
} from "../service/jobconfigApi";
import { useDispatch, useSelector } from "react-redux";
import logoutIcon from "../assets/image/logoutIcon.png";
import { toast } from "react-toastify";
import { logoutApi } from "../service/authApi";
import Swal from "sweetalert2";
import userMIcon from "../assets/image/userMIcon.png";
import { baseUrlForFile, currentUser } from "../helpers";
import { updateProfile, getProfile } from "../service/userManagement";
import { setProfile } from "../redux/feature/profileSlice";
import { useSidebar } from "../contexts/sidebarContext";
import { Tooltip } from "@mui/material";

const Sidebar = ({ toggleHandler }) => {
  const { getConfiguration, jobConfigs, setJobConfigs } = useSidebar();

  const [activeSubMenu, setActiveSubMenu] = useState(null);
  const [activeSubMenu1, setActiveSubMenu1] = useState(null);
  const [activeMenu, setActiveMenu] = useState(null);
  const [copyJob, setCopyJob] = useState();
  const jobUpdateFlag = useSelector((state) => state.jobSlice.jobUpdateFlag);
  const profile = useSelector((state) => state.profile);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userInfo = JSON.parse(localStorage.getItem("AUTH_USER"));
  const userRole = userInfo?.userRole;
  const subMenuRef = useRef(null);
  const uploadImageRef = useRef(null);

  const selectedCompanyLogoImage = useSelector(
    (state) => state.profile.companyLogoImage
  );

  const toggleSubMenu = (menu) => {
    if (activeSubMenu === menu) {
      setActiveSubMenu(null);
    } else {
      setActiveSubMenu(menu);
      setActiveSubMenu1(null);
    }
  };

  const handleSubMenuClick = (job, e) => {
    e.stopPropagation();
    setActiveSubMenu1(job.id);
    setActiveMenu("settings");
  };

  const userID = userInfo?.userId;
  const ParentID = userInfo?.createdBy;
  const handleCopyJob = async (id, event) => {
    event.stopPropagation();
    try {
      const response = await GetjobConfigByID(id);
      if (response?.data) {
        const jobToCopy = response.data[0];
        const originalName = jobToCopy.jobConfigName;

        const extractBaseName = (name) => {
          const suffixRegex = /-(\d+)$/;
          if (suffixRegex.test(name)) {
            return name.replace(suffixRegex, "");
          }
          return name;
        };

        const baseName = extractBaseName(originalName);

        let maxSuffix = 0;

        jobConfigs.forEach((job) => {
          const name = job.jobConfigName;
          if (name === baseName) {
            maxSuffix = Math.max(maxSuffix, 0);
          } else {
            const regex = new RegExp(`^${baseName}-(\\d+)$`);
            const match = name.match(regex);
            if (match) {
              const num = parseInt(match[1], 10);
              if (!isNaN(num)) {
                maxSuffix = Math.max(maxSuffix, num);
              }
            }
          }
        });

        const newJobConfigName = `${baseName}-${maxSuffix + 1}`;

        const newJobData = {
          jobConfigName: newJobConfigName,
          jobConfigDescription: jobToCopy.jobConfigDescription,
          monthlyVariableCost: jobToCopy.monthlyVariableCost,
          amount: jobToCopy.amount,
          overheadCostMonthlyHours: jobToCopy.overheadCostMonthlyHours,
          ownersPayMonthlyHours: jobToCopy.ownersPayMonthlyHours,
          loansMonthlyHours: jobToCopy.loansMonthlyHours,
          others: jobToCopy.others,
          companyAdminId:
            userRole === "CompanyAdmin"
              ? userID
              : userRole === "CompanyManager"
              ? ParentID
              : "",
          totalAmount: jobToCopy.totalAmount,
          laborCostHigh: jobToCopy.laborCostHigh,
          laborCostMid: jobToCopy.laborCostMid,
          laborCostLow: jobToCopy.laborCostLow,
          breakEvenHigh: jobToCopy.breakEvenHigh,
          breakEvenMid: jobToCopy.breakEvenMid,
          breakEvenLow: jobToCopy.breakEvenLow,
        };
        delete newJobData.id;

        setJobConfigs((prevJobConfigs) => [...prevJobConfigs, newJobData]);

        await jobConfiguration(newJobData);

        toast.success("Job copied successfully!");
        getConfiguration();
      }
    } catch (error) {
      console.error("Error copying job:", error);
      toast.error("An error occurred while copying the job.");
    }
  };

  useEffect(() => {
    if (activeMenu === "JobConfiguration") {
      getConfiguration();
    }
  }, [jobUpdateFlag, activeMenu]);

  useEffect(() => {
    if (activeMenu !== "settings") {
      setActiveSubMenu(null);
    }
  }, [activeMenu]);

  const handleLogout = async (e) => {
    e.preventDefault();

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You want to Logout",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, logout!",
    });

    if (result.isConfirmed) {
      const token = localStorage.getItem("AUTH_ACCESS_TOKEN");

      if (!token) {
        toast.error("No token found. Please log in again.");
        navigate("/");
        return;
      }

      try {
        const resp = await logoutApi(token);
        if (resp.status) {
          setTimeout(() => {
            toast.success(resp.message);
          }, 0);
          localStorage.clear();

          navigate("/");
        } else {
          setTimeout(() => {
            toast.success("User logged out successfully");
          }, 0);

          localStorage.clear();
          window.location.href = "/";
        }
      } catch (error) {
        console.error(
          "Logout error:",
          error.response ? error.response.data : error.message
        );

        localStorage.clear();
        window.location.href = "/";
      }
    }
  };

  const handleEditCompanyLogo = async (logoImg) => {
    const {
      userId,
      firstName,
      lastName,
      email,
      phoneNumber,
      companyName,
      companyId,
      address1,
      address2,
      city,
      province,
      country,
      postalCode,
    } = profile;

    const formData = new FormData();

    if (logoImg) formData.append("CompanyLogoImage", logoImg);
    else return;
    if (userId) formData.append("userId", userId);
    if (firstName) formData.append("firstName", firstName);
    if (lastName) formData.append("lastName", lastName);
    if (email) formData.append("email", email);
    if (phoneNumber) formData.append("phoneNumber", phoneNumber);
    if (companyName) formData.append("companyName", companyName);
    if (companyId) formData.append("companyId", companyId);
    if (address1) formData.append("address1", address1);
    if (address2) formData.append("address2", address2);
    if (city) formData.append("city", city);
    if (province) formData.append("province", province);
    if (country) formData.append("country", country);
    if (postalCode) formData.append("postalCode", postalCode);

    try {
      const response = await updateProfile(formData);

      if (response) {
        toast.success("Company logo updated successfully!");
        getProfile(currentUser().userId).then((data) => {
          if (data?.data) {
            dispatch(setProfile(data?.data));
          }
        });
      }
    } catch (error) {
      toast.error("Failed to update company logo. Please try again.");
    }
  };

  return (
    <div className="side-bar">
      <div className="brandArea text-center d-flex justify-content-center">
        <span onClick={toggleHandler} className="sidebar-toggle">
          <FontAwesomeIcon icon={faArrowLeft} />
        </span>
        <div className="position-relative">
          <Link to="/Dashboard">
            <img
              className="m-0"
              style={{ width: "80px", height: "80px", objectFit: "contain" }}
              src={baseUrlForFile + "/" + selectedCompanyLogoImage}
              alt=""
              onError={({ currentTarget }) => {
                currentTarget.src = logo;
              }}
            />
          </Link>

          {(userRole === "CompanyAdmin" || userRole === "SuperAdmin") && (
            <>
              <input
                ref={uploadImageRef}
                className="d-none"
                type="file"
                onChange={(e) => {
                  handleEditCompanyLogo(e.target.files[0]);
                }}
              />
              <FontAwesomeIcon
                className="edit-company-logo-icon"
                onClick={() => {
                  uploadImageRef.current?.click();
                }}
                icon={faPencil}
              />
            </>
          )}
        </div>
      </div>
      <div className="menubar">
        <div className="menu">
          {userRole && (
            <>
              <div className="item">
                <Link
                  to="/Dashboard"
                  className={activeMenu === "dashboard" ? "nav-active" : ""}
                  onClick={() => setActiveMenu("dashboard")}
                >
                  <img src={dashboard} alt="" />
                  <span>Dashboard</span>
                </Link>
              </div>

              {(userRole === "CompanyAdmin" ||
                userRole === "CompanyManager") && (
                <div className="item">
                  <Link
                    to="/UserManagement"
                    className={
                      activeMenu === "userManagement" ? "nav-active" : ""
                    }
                    onClick={() => setActiveMenu("userManagement")}
                  >
                    <img src={umanage} alt="" />
                    <span>User Management</span>
                  </Link>
                </div>
              )}
              {userRole === "CompanyUser" && (
                <div className="item">
                  <Link
                    to="/AllJobs"
                    className={activeMenu === "AllJobs" ? "nav-active" : ""}
                    onClick={() => setActiveMenu("AllJobs")}
                  >
                    <img src={arevenue} alt="" />
                    <span>Create Jobs</span>
                  </Link>
                </div>
              )}
              {(userRole === "CompanyAdmin" ||
                userRole === "CompanyManager") && (
                <div className="item">
                  <div className="position-relative">
                    <div className="start_class"></div>

                    <NavLink
                      to="/jobConfiguration"
                      className={`sub-btn position-relative ${
                        activeMenu === "settings" ? "nav-active" : ""
                      }`}
                    >
                      <img src={settings} alt="" />
                      <span>Job Configuration</span>
                      <FontAwesomeIcon
                        icon={faAngleRight}
                        className={`dropdown ${
                          activeSubMenu === "settings" ? "rotate" : ""
                        }`}
                        onClick={() => {
                          setActiveMenu("JobConfiguration");
                          toggleSubMenu("settings");
                        }}
                      />
                    </NavLink>
                  </div>
                  {/* {activeSubMenu === "settings" && (
                    <div className="sub-menu" ref={subMenuRef}>
                      {jobConfigs?.map((job) => (
                        <>
                          <Link
                            key={job.id}
                            className={`sub-item ${
                              activeSubMenu1 === job.id ? "active" : ""
                            }`}
                            to={`/jobConfiguration/${job.id}`}
                            state={job}
                            handleSubMenuClick
                            onClick={() => handleSubMenuClick(job)}
                          >
                            <FontAwesomeIcon icon={faPencil} className="me-2" />
                            <span>{job.jobConfigName}</span>
                            <FontAwesomeIcon
                              icon={faCopy}
                              className="me-2 mx-2"
                            />
                          </Link>
                        </>
                      ))}
                    </div>
                  )} */}
                  {activeSubMenu === "settings" && (
                    <div
                      className="sub-menu "
                      // style={{ overflowY: "auto" }}
                      ref={subMenuRef}
                    >
                      {jobConfigs?.map((job) => (
                        <div key={job.id} className="d-flex">
                          <div
                            className="col-lg-10"
                            style={{ overflow: "hidden" }}
                          >
                            <NavLink
                              key={job.id}
                              className={`sub-item ${
                                activeSubMenu1 === job.id ? "active" : ""
                              }`}
                              to={`/jobConfiguration/${job.id}`}
                              state={job}
                              onClick={(e) => {
                                handleSubMenuClick(job, e);
                              }}
                              style={{
                                textWrap: "nowrap",
                                textOverflow: "ellipsis",
                                maxWidth: "190px",
                                overflow: "hidden",
                              }}
                            >
                              <FontAwesomeIcon
                                icon={faPencil}
                                className="me-2"
                              />
                              <Tooltip title={job.jobConfigName}>
                                <span>{job.jobConfigName}</span>
                              </Tooltip>
                              {/* <span> {copyJob}</span> */}
                            </NavLink>
                          </div>
                          <div
                            className="col-lg-1 m-auto"
                            onClick={(e) => {
                              handleCopyJob(job.id, e);
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faCopy}
                              className="me-2 mx-2"
                              style={{ cursor: "pointer" }}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}

              {(userRole === "CompanyAdmin" ||
                userRole === "CompanyUser" ||
                userRole === "CompanyManager") && (
                <div className="item">
                  <Link
                    to="/AdditionalRevenue"
                    className={
                      activeMenu === "additionalRevenue" ? "nav-active" : ""
                    }
                    onClick={() => setActiveMenu("additionalRevenue")}
                  >
                    <img src={arevenue} alt="" />
                    <span>Additional Revenue</span>
                  </Link>
                </div>
              )}
              {userRole === "CompanyAdmin" && (
                <div className="item">
                  <Link
                    to="/CompanyManager"
                    className={
                      activeMenu === "CompanyManager" ? "nav-active" : ""
                    }
                    onClick={() => setActiveMenu("CompanyManager")}
                  >
                    <img src={userMIcon} alt="" />
                    <span>Company Manager</span>
                  </Link>
                </div>
              )}

              {userRole === "SuperAdmin" && (
                <div className="item">
                  <Link
                    to="/UploadExcel"
                    className={activeMenu === "UploadExcel" ? "nav-active" : ""}
                    onClick={() => setActiveMenu("UploadExcel")}
                  >
                    <img src={xls} alt="" />
                    <span>Manage Excel</span>
                  </Link>
                </div>
              )}

              {userRole === "SuperAdmin" && (
                <div className="item">
                  <div className="position-relative">
                    <div className="start_class"></div>

                    <Link
                      to="/content-management"
                      className={`sub-btn position-relative ${
                        activeMenu === "settings" ? "nav-active" : ""
                      }`}
                      onClick={() => {
                        setActiveMenu("JobConfiguration");
                        toggleSubMenu("settings");
                      }}
                    >
                      <img src={settings} alt="" />
                      <span>Content Management</span>
                      {/* <FontAwesomeIcon
                        icon={faAngleRight}
                        className={`dropdown ${
                          activeSubMenu === "settings" ? "rotate" : ""
                        }`}
                      /> */}
                    </Link>
                  </div>
                </div>
              )}
              {/* {userRole === "CompanyAdmin" && (
                <div className="item">
                  <Link
                    to="/AllJobs"
                    className={`sub-btn ${
                      activeMenu === "/AllJobs" ? "nav-active" : ""
                    }`}
                    onClick={() => {
                      setActiveMenu("/AllJobs");
                      toggleSubMenu("/AllJobs");
                    }}
                  >
                    <img src={settings} alt="" />
                    <span>User List</span>
                    <FontAwesomeIcon
                      icon={faAngleRight}
                      className={`dropdown ${
                        activeSubMenu === "/AllJobs" ? "rotate" : ""
                      }`}
                    />
                  </Link>
                  {activeSubMenu === "/AllJobs" && (
                    <div className="sub-menu" ref={subMenuRef}>
                      {addUser?.map((user) => (
                        <Link
                          key={state?.id}
                          to={`/AllJobs/${state?.id}`}
                          state={user}
                          onClick={() => handleSubMenuClick(user)}
                        >
                          <FontAwesomeIcon icon={faPencil} className="me-2" />
                          <span>
                            {user?.firstName} {user?.lastName}
                          </span>
                        </Link>
                      ))}
                      {addUser?.length === 0 && (
                        <div className="no-users">
                          <span>No users found</span>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )} */}

              <div className="d-flex justify-content-center logoutbtnArea p-3 position-absolute bottom-0 w-100">
                <Link to="" className="btn btn-dark" onClick={handleLogout}>
                  {" "}
                  <img src={logoutIcon} alt="" /> <span>Logout</span>
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
